const BLOCKED_DOMAINS = [
  'gmail',
  'hotmail',
  'yahoo',
  'student',
  'riminder',
  'outlook',
  'aol',
  'yopmail',
  'orange',
  'icloud',
  'live',
  'sfr',
  'wanadoo',
  'fakeinbox',
  'temp-mail',
  'lcloud',
];

export const isValidWorkEmail = (email) => {
  if (!email) return false;
  const domain = email.split('@')[1]?.toLowerCase();
  return domain && !BLOCKED_DOMAINS.some(blockedDomain => 
    domain.includes(blockedDomain.toLowerCase())
  ) && !domain.endsWith('.edu');
};

export const getEmailErrorMessage = (email) => {
  const domain = email.split('@')[1];
  if (!domain) return "You need a work email.";
  return `You need a work email. @${domain} emails are not accepted.`;
};
